





































































































































import { debounce, get } from 'lodash';
import moment from 'moment';
import { Contract } from 'sp-common/src/types/opti/Contract';
import { Vessel } from 'sp-common/src/types/opti/Vessel';
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';

import SparkIcon from '@/components/icons/SparkIcon.vue';
import { sparkFormat } from '@/utils/opti/sparkFormat';
import { analyticsTrack } from '@/utils/usageAnalytics';

import { OptiState } from '../../store/modules/opti';
import { checkVesselCompatibility } from '../../utils/opti/checkVesselCompatibility';

const debouncedAnalyticsTrack = debounce(analyticsTrack, 1000);
const opti = namespace('opti');

@Component({
  components: {
    SparkIcon,
  },
})
export default class VesselForm extends Vue {
  @opti.State vessels!: Vessel[];
  @opti.State vessel?: Vessel;
  @opti.State startContract!: Contract;
  @opti.State destinationContracts!: Contract[];
  @opti.State profitResults!: OptiState['profitResults'];
  @opti.State input!: OptiState['input'];
  @opti.Action calculateProfits: any;
  @opti.Mutation setVessel: any;
  @opti.Mutation setStartContractVolume: any;
  @opti.Mutation setVesselSpeed: any;
  @opti.Mutation setInputCharterCost: any;
  @opti.Mutation setInputHeel: any;
  searchTerm = '';
  sparkFormat = sparkFormat;

  get loading() {
    return !this.vessel || !this.charterRateInUsdPerDay;
  }

  get allLocations() {
    return [
      this.startContract.location!,
      ...this.destinationContracts.map((contract) => contract.location!),
    ];
  }
  get isSparkPrice() {
    return this.analysisCharterCost === this.charterRateInUsdPerDay;
  }

  get charterRateInUsdPerDay() {
    return this.input.charterRate;
  }

  get dischargeableVolume() {
    const firstResult = this.profitResults && this.profitResults[0];
    return get(firstResult, 'scenarios.base.costs.dischargeableVolume');
  }

  get charterRate() {
    const firstResult = this.profitResults && this.profitResults[0];
    return get(firstResult, 'scenarios.base.costs.charter.charterRate');
  }

  get percentOfSparkRate() {
    if (!this.charterRateInUsdPerDay) return 0;
    return this.charterRateInUsdPerDay / this.charterRate.usdPerDay;
  }

  get charterRateMonth() {
    return moment(this.charterRate.deliveryMonth).format('MMM YY');
  }

  get analysisCharterCost() {
    return this.charterRate.usdPerDay;
  }

  get vesselValue() {
    if (this.filteredVessels.length) {
      return this.vesselId;
    } else if (this.vessel) {
      return this.vessel.name;
    } else {
      return null;
    }
  }

  get filteredVessels() {
    if (!this.searchTerm.length) {
      return [];
    }
    return this.vessels
      .filter((vessel) =>
        vessel.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
      .map((vessel) => {
        const compatible = checkVesselCompatibility(vessel, this.allLocations);
        return {
          compatible,
          ...vessel,
        };
      })
      .sort((vesselA, vesselB) => +vesselB.compatible - +vesselA.compatible);
  }

  get vesselId() {
    return this.vessel && this.vessel.id;
  }
  handleSearch(value: string) {
    return (this.searchTerm = value);
  }
  resetToSparkPrice() {
    analyticsTrack('OPTI_CHARTERRATE_RESET');
    this.setInputCharterCost(this.analysisCharterCost);
  }

  changeSpeed(val: number) {
    debouncedAnalyticsTrack('OPTI_VESSELSPEED_SLIDE');
    this.setVesselSpeed(val);
  }
  changeCharterCost(val: number) {
    debouncedAnalyticsTrack('OPTI_CHARTERRATE_SLIDE');
    this.setInputCharterCost(val);
  }
  changeLngHeelVolume(val: number) {
    debouncedAnalyticsTrack('OPTI_HEELVOLUME_SLIDE');
    this.setInputHeel(val);
  }

  selectVessel(val: string) {
    const vessel = this.filteredVessels.find((v) => v.id === val);
    if (vessel && !vessel.compatible) {
      this.$message.warning(
        'The selected vessel may be incompatible with some of the locations'
      );
    }
    this.setVessel(vessel);
    this.searchTerm = '';
    this.calculateProfits();
  }

  next() {
    if (!this.vessel) return;

    // Prefill load volume with vessel capacity
    const volumeInTBTu = this.vessel.capacity.tbtu;
    this.setStartContractVolume(volumeInTBTu);

    this.$router.push('5');
  }
}
